import axios from 'axios'
import ILogin from '../interfaces/ILogin'

export const login = (login: ILogin): Promise<any> => {
  return axios.post('auth/login', login)
}

export const user = (): Promise<any> => axios.get('auth/user')
